import { FunctionComponent, memo } from "react";
import {
    Cell,
    Column,
    Header,
    Heading,
    Pagination,
    Table,
    TableColumns,
    TableFooter,
} from "@edgetier/client-components";
import CreateSpellingExemptionButton from "./create-spelling-exemption-button";
import SpellingConfigurationActionsMenu from "./spelling-configuration-actions-menu";
import SpellingConfigurationLanguageCell from "./spelling-configuration-language-cell";
import { useLanguages } from "hooks-for/filters/use-languages";
import { ISpellingExemption } from "@edgetier/watchtower-types";
import { IProps } from "./spelling-configuration-table.types";
import "./spelling-configuration-table.scss";

/**
 * Display spelling exceptions as table
 * @param props.spellingExemptions  Paginated list of spelling exclusions
 */
const SpellingConfigurationTable: FunctionComponent<IProps> = ({ spellingExemptions, ...tableProps }) => {
    const { data: languages } = useLanguages({}, { staleTime: 1000 * 60 * 30 });

    return (
        <div className="spelling-configuration__table">
            <Table
                getRowKey={({ spellingExemptionId }) => spellingExemptionId}
                rows={spellingExemptions}
                pageSize={10}
                {...tableProps}
            >
                <Header>
                    <Pagination showPageNumbers={false} />
                </Header>
                <TableColumns>
                    <Column>
                        <Heading>Exemption</Heading>
                        <Cell<ISpellingExemption>>{({ exemption }) => exemption}</Cell>
                    </Column>
                    <Column>
                        <Heading>Language</Heading>
                        <Cell<ISpellingExemption>>
                            {({ languageIsoCode }) => (
                                <SpellingConfigurationLanguageCell
                                    languages={languages ?? []}
                                    languageIsoCode={languageIsoCode}
                                />
                            )}
                        </Cell>
                    </Column>
                    <Column>
                        <Heading>&nbsp;</Heading>
                        <Cell<ISpellingExemption>>
                            {(exemption) => <SpellingConfigurationActionsMenu exemption={exemption} />}
                        </Cell>
                    </Column>
                </TableColumns>
                <TableFooter>
                    <CreateSpellingExemptionButton />
                </TableFooter>
            </Table>
        </div>
    );
};

export default memo(SpellingConfigurationTable);
